var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from 'react';
import ConfigurationComponent from './../../base/ConfigurationComponent';
var ChartNavigatorSeriesMarkers = function (props) {
    return (React.createElement(ConfigurationComponent, __assign({}, props, { _chartKey: "markers" })));
};
export default ChartNavigatorSeriesMarkers;
//# sourceMappingURL=Markers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-charts/dist/es/components/navigator/series-item/Markers.js
// module id = 2557
// module chunks = 29